import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GlobalModule } from 'src/app/global/global.module';
import { GestaoDDMainComponent } from './gestao-dd-main/gestao-dd-main.component';

@NgModule({
  declarations: [GestaoDDMainComponent],
  imports: [CommonModule, GlobalModule],
})
export class GestaoDDModule {}
